import { Box, Typography, TextField } from "@mui/material";
import CustomButton from "../controls/CustomButton";

export default function StartOrbitSendModal({ handleGoBack, selectedPartnerType, selectedPartner, handleDeleteRequest, reasonError, setReason, reason }) {
    return (
        <>
            <div className="send_to_orbit_modal_wrapper">
                <Box className="modal-s-orbit">
                    <Typography
                        id="modal-title"
                        variant="h6"
                        sx={{ fontSize: "14px", marginBottom: "15px" }}
                    >
                        Are you sure you want to cancel exclusive partnership request?
                    </Typography>
                    <div>
                        <TextField
                            sx={{ marginBottom: "15px" }}
                            label="Reason for cancellation"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={4}
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            error={Boolean(reasonError)}
                            helperText={reasonError || " "}
                        />
                    </div>
                </Box>
            </div>
            <div className="progressmodal_footer">
                <CustomButton
                    label="Yes"
                    action={handleDeleteRequest}
                    disabled={
                        selectedPartnerType !== "Any Partner" &&
                        !selectedPartner
                    }
                />
                <CustomButton
                    label="No"
                    action={handleGoBack}
                    disabled={
                        selectedPartnerType !== "Any Partner" &&
                        !selectedPartner
                    }
                />
            </div>
        </>
    )
}
